import React from 'react';
import styles from './GearDetailsPageSkeleton.module.css';

function GearDetailsPageSkeleton() {
  return (
    <div className={styles.contentSection}>
      {/* Left Panel */}
      <div className={styles.leftPanel}>
        <div className={`${styles.skeletonBlock} ${styles.backButton}`}>
          <div className={styles.shimmer}></div>
        </div>

        <div className={styles.productHeader}>
          <div className={`${styles.skeletonBlock} ${styles.breadcrumb}`}>
            <div className={styles.shimmer}></div>
          </div>
          
          <div className={styles.titleRow}>
            <div className={`${styles.skeletonBlock} ${styles.title}`}>
              <div className={styles.shimmer}></div>
            </div>
            
            <div className={styles.actionsGroup}>
              <div className={`${styles.skeletonBlock} ${styles.actionButton}`}>
                <div className={styles.shimmer}></div>
              </div>
              <div className={`${styles.skeletonBlock} ${styles.actionButton}`}>
                <div className={styles.shimmer}></div>
              </div>
            </div>
          </div>

          <div className={`${styles.skeletonBlock} ${styles.brand}`}>
            <div className={styles.shimmer}></div>
          </div>
        </div>

        <div className={`${styles.skeletonBlock} ${styles.mainImage}`}>
          <div className={styles.shimmer}></div>
        </div>
        <div className={styles.metaRow}>
          <div className={`${styles.skeletonBlock} ${styles.metaBlock}`}>
            <div className={styles.shimmer}></div>
          </div>
          <div className={`${styles.skeletonBlock} ${styles.metaBlock}`}>
            <div className={styles.shimmer}></div>
          </div>
        </div>
      </div>

      {/* Right Panel */}
      <div className={styles.rightPanel}>
        <div className={`${styles.skeletonBlock} ${styles.descriptionCard}`}>
          <div className={styles.shimmer}></div>
        </div>
        <div className={`${styles.skeletonBlock} ${styles.commentSection}`}>
          <div className={styles.shimmer}></div>
        </div>
      </div>
    </div>
  );
}

export default GearDetailsPageSkeleton;
